import { z } from 'zod';

/**
 * Core student feedback schemas that are shared across multiple files.
 * This file helps avoid circular dependencies by providing a central location
 * for core student feedback-related schemas that are used by both student.ts and student-feedbacks.ts.
 */

export const studentFeedbackIssueSchema = z.enum([
  'attendance_issue',
  'behavior_issue',
  'tech_issue',
  'learning_issue',
]);
export type StudentFeedbackIssue = z.infer<typeof studentFeedbackIssueSchema>;
export const StudentFeedbackIssue = studentFeedbackIssueSchema.enum;

export const StudentFeedbackIssueLabelMap: Record<StudentFeedbackIssue, string> = {
  [StudentFeedbackIssue.attendance_issue]: 'Attendance issue',
  [StudentFeedbackIssue.behavior_issue]: 'Behavior issue',
  [StudentFeedbackIssue.tech_issue]: 'Tech issue',
  [StudentFeedbackIssue.learning_issue]: 'Learning issue',
};

export const studentFeedbackStatusSchema = z.enum(['need_review', 'check_again', 'resolved']);
export type StudentFeedbackStatus = z.infer<typeof studentFeedbackStatusSchema>;
export const StudentFeedbackStatus = studentFeedbackStatusSchema.enum;

export const StudentFeedbackStatusLabelMap: Record<StudentFeedbackStatus, string> = {
  [StudentFeedbackStatus.need_review]: 'Need review',
  [StudentFeedbackStatus.check_again]: 'Check again',
  [StudentFeedbackStatus.resolved]: 'Resolved',
};
